import React, { useEffect, useState, useRef } from "react";
import { Eye } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import SOPInstanceOpenLayerSource from "./SOPInstanceOpenLayerSource";
import Draw from "ol/interaction/Draw";
import "ol/ol.css";
import "./ViewedSopInstanceMap.css";
import { FaMap, FaMapMarked } from "react-icons/fa";
 
const ViewedSopInstanceMap = () => {
  const navigate = useNavigate();
  const center = { lat: 25.747554, lng: 85.562257 };
  const zoom = 8;
 
  const [map, setMap] = useState(null);
  const [source, setSource] = useState(null);
  const [draw, setDraw] = useState(null);
 
  const setMapInstance = (mapInstance, sourceInstance) => {
    setMap(mapInstance);
    setSource(sourceInstance);
  };
 
  const drawInteraction = (option) => {
    if (option !== "None" && map && source) {
      let drawInst = new Draw({
        source: source,
        type: option,
      });
 
      map.addInteraction(drawInst);
      setDraw(drawInst);
 
      drawInst.on("drawend", (event) => {
        event.stopPropagation();
        event.preventDefault();
        map.removeInteraction(drawInst);
      });
    }
  };
 
  return (
    <>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          className="card-title"
          style={{
            color: "#2A6591",
            textAlign: "left",
            marginLeft: "10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FaMapMarked style={{ position: "relative", top: "-4px" }} />{" "}
          <span>Active Incident</span>
        </div>
 
        <div>
          <Eye
            size={20}
            onClick={() => navigate("/main-dashboard/dmsdashboard")}
            style={{ color: "#2A6591", cursor: "pointer", marginTop: "10px" }}
          />
        </div>
      </div> */}
 
      {/* Map Container */}
      <div style={{ width: "100%", height: "400px", marginTop: "20px" }}>
        <SOPInstanceOpenLayerSource
          zoom={zoom}
          center={center}
          onmapload={setMapInstance}
        />
      </div>
    </>
  );
};
 
export default ViewedSopInstanceMap;
 
 